import { Easing, interpolate, useCurrentFrame, useVideoConfig } from 'remotion'
import { Speaker } from '../types'
import Participant from './Participant'
import { useResponsiveSceneProps } from './ResponsiveSceneContext'

export interface HorizontalParticipantsProps {
  speakers: Speaker[]
}

export default function HorizontalParticipants({
  speakers,
}: HorizontalParticipantsProps) {
  const { u, w, h } = useResponsiveSceneProps()
  const frame = useCurrentFrame()
  const { fps } = useVideoConfig()
  const time = frame / fps

  const y = (t: number) =>
    interpolate(t, [0, 0.5], [u(3), 0], {
      extrapolateLeft: 'clamp',
      extrapolateRight: 'clamp',
      easing: Easing.out(Easing.exp),
    })

  const opacity = (t: number) =>
    interpolate(t, [0, 0.25], [0, 1], {
      extrapolateLeft: 'clamp',
      extrapolateRight: 'clamp',
    })

  const item = (t: number) => ({
    opacity: opacity(t),
    transform: `translateY(${y(t)}px)`,
  })

  return (
    <div
      className="absolute flex flex-row space-x-14"
      style={{
        bottom: u(4),
        left: u(4),
        transform: `translateY(50%)`,
      }}
    >
      {speakers.map((speaker) => (
        <div key={speaker.name} style={item(time - 0.1)}>
          <Participant size={u(2.5)} speaker={speaker} />
        </div>
      ))}
    </div>
  )
}
